module.exports = __webpack_public_path__ + "gb.svg?85a97dab5b090c1a8110d27fcd570939";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/gb.svg
// module id = 1362
// module chunks = 0